import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { TranslateLangPipe } from '@gs-2.0/shared';

@Component({
  selector: 'app-donation-form-header',
  standalone: true,
  imports: [TranslateLangPipe],
  templateUrl: './donation-form-header.component.html',
  styleUrl: './donation-form-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DonationFormHeaderComponent {
  // Variant control
  variant = input<'default' | 'givelink' | 'auth'>('default');

  // GiveLink variant inputs
  fundName = input<string>('');
  isLoading = input<boolean>(false);

  // Default variant inputs (with sensible defaults)
  title = input<string>('contribute.charity_finder.title');
  subtitle = input<string>('contribute.charity_finder.subtitle');

  // Computed properties for template
  isGiveLink = computed(() => this.variant() === 'givelink');
  isDefault = computed(() => this.variant() === 'default');
  isAuth = computed(() => this.variant() === 'auth');
}
